var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-radio-group',{attrs:{"size":"small"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},_vm._l((_vm.radioGroupList),function(item,index){return _c('el-radio-button',{key:index,attrs:{"label":index+''}},[_vm._v(" "+_vm._s(item)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }